import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { app } from "@microsoft/teams-js";
import { Container, InfoText } from "components/ui";

const Block = styled.div`
  margin: 16px 0;
  line-height: 1.5;
  color: #605e5c;
  white-space: pre-line;
`;

const Code = styled.code`
  background: #f3f2f1;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
  display: inline-block;
  word-break: break-all;
`;

const AuthConsent: React.FC = () => {
  const [adminConsent, setAdminConsent] = useState<boolean | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [errorDescription, setErrorDescription] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const adminParam = params.get("admin_consent");
    const errorParam = params.get("error");
    const errorDescParam = params.get("error_description");

    setAdminConsent(adminParam === "True" || adminParam === "true");
    setError(errorParam);
    setErrorDescription(errorDescParam);

    app.initialize().catch(() => {});
  }, []);

  const success = adminConsent === true && !error;
  const failed = !!error;

  return (
    <Container>
      <InfoText
        style={{
          fontSize: "20px",
          fontWeight: "700",
          color: success ? "#107c10" : failed ? "#d13438" : "#323130",
        }}
      >
        {success
          ? "Consent Granted"
          : failed
          ? "Consent Error"
          : "Consent Status"}
      </InfoText>
      {success && (
        <>
          <Block>Admin consent has been granted for this application.</Block>
          <Block>
            Next steps:
            {"\n"}1. Return to Microsoft Teams
            {"\n"}2. Close and reopen the Perkbox app
            {"\n"}3. Enjoy the recognition feature in Teams!
          </Block>
        </>
      )}

      {failed && (
        <>
          <Block>
            <strong>Error:</strong> <Code>{error}</Code>
          </Block>
          {errorDescription && (
            <Block>
              <strong>Details:</strong>{" "}
              <Code>{decodeURIComponent(errorDescription)}</Code>
            </Block>
          )}
          <Block>
            If this is a conditional access or MFA prompt (e.g. AADSTS50097),
            complete required steps, then retry granting admin consent.
          </Block>
        </>
      )}

      {adminConsent === null && !error && (
        <Block>
          Awaiting consent status. If this page was opened directly, close it.
        </Block>
      )}
    </Container>
  );
};

export default AuthConsent;
